<script>import { cfgReownProjectId, stateTheme, stateUi, Theme } from "@infinitro/config";
import { locale } from "@infinitro/global";
import { connect } from "@infinitro/wallet_verify";
import { onMount } from "svelte";
import { get } from "svelte/store";
import MetaMaskIcon from "../icons/metamask.svelte";
import WalletConnectIcon from "../icons/walletconnect.svelte";
const theme = get(stateTheme);
const projectId = cfgReownProjectId();
const onClick = (event) => {
  event?.preventDefault();
  event?.stopPropagation();
  connect();
};
$: useSolidStatic = $stateUi.button.buttonStyle === "solid-static";
$: useContrast = $stateUi.button.buttonStyle === "contrast";
</script>

{#if projectId}
	<button
		class:button-solid-static={useSolidStatic || useContrast}
		type="button"
		class="google"
		on:click={onClick}
	>
		<MetaMaskIcon />
	</button>
	<button
		class:button-solid-static={useSolidStatic || useContrast}
		type="button"
		class="google"
		on:click={onClick}
	>
		<WalletConnectIcon />
	</button>
{/if}

<style>
	button {
		display: flex;
		height: 40px;
		width: 100%;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		border-width: 1px;
		border-color: var(--color-neutral-900);
		padding-left: 0.25rem;
		padding-right: 0.25rem;
		padding-top: 1rem;
		padding-bottom: 1rem;
		text-align: center;
		background: var(--gradient-alternative-4)
}
	button:hover {
		border-color: var(--color-neutral-100)
}
	.button-solid-static {
		border-color: var(--color-accent-700);
		background-color: var(--color-secondary-500);
		background-image: unset
}
</style>
